export default [
  { label: 'Transação', value: 'protocol_number' },
  { label: 'Tipo', value: 'eventable_type' },
  { label: 'Detalhes', value: 'details' },
  { label: 'Vlr. Total', value: 'total_amount' },
  { label: 'Tarifas', value: 'fee_total_amount' },
  { label: 'Filial da empresa', value: 'client_branch' },
  { label: 'Cartão', value: 'card' },
  { label: 'Autor', value: 'author' },
  { label: 'Data e Hora', value: 'created_at' },
];
